import { render, staticRenderFns } from "./RegistrationFieldsTable.vue?vue&type=template&id=fc3c9dfe&scoped=true"
import script from "./RegistrationFieldsTable.vue?vue&type=script&lang=js"
export * from "./RegistrationFieldsTable.vue?vue&type=script&lang=js"
import style0 from "./RegistrationFieldsTable.vue?vue&type=style&index=0&id=fc3c9dfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3c9dfe",
  null
  
)

export default component.exports